/* ForzaGroup Dawn v6 — 出荷予定日 / 文字入れトグル / スウォッチ / カレンダー / 数量 / メディア切替 */
(function () {
  // 出典: 内閣府CSV（2026年・2027年は実値との一致を検証済み）。
  // 2028年〜2030年は法令ルールで算出した暫定値。春分・秋分は前年2月の官報公示で確定するため、毎年2月に要確認。
  // 会社休業日として、お盆8/13〜16と年末年始12/29〜1/3を各年に含む（秘書の想定値）。
  // 2031年分は追記が必要。
  var HOLIDAYS = ['2026-01-01','2026-01-12','2026-02-11','2026-02-23','2026-03-20','2026-04-29','2026-05-03','2026-05-04','2026-05-05','2026-05-06','2026-07-20','2026-08-11','2026-08-13','2026-08-14','2026-08-15','2026-08-16','2026-09-21','2026-09-22','2026-09-23','2026-10-12','2026-11-03','2026-11-23','2026-12-29','2026-12-30','2026-12-31','2027-01-01','2027-01-02','2027-01-03','2027-01-11','2027-02-11','2027-02-23','2027-03-21','2027-03-22','2027-04-29','2027-05-03','2027-05-04','2027-05-05','2027-07-19','2027-08-11','2027-08-13','2027-08-14','2027-08-15','2027-08-16','2027-09-20','2027-09-23','2027-10-11','2027-11-03','2027-11-23','2027-12-29','2027-12-30','2027-12-31','2028-01-01','2028-01-02','2028-01-03','2028-01-10','2028-02-11','2028-02-23','2028-03-20','2028-04-29','2028-05-03','2028-05-04','2028-05-05','2028-07-17','2028-08-11','2028-08-13','2028-08-14','2028-08-15','2028-08-16','2028-09-18','2028-09-22','2028-10-09','2028-11-03','2028-11-23','2028-12-29','2028-12-30','2028-12-31','2029-01-01','2029-01-02','2029-01-03','2029-01-08','2029-02-11','2029-02-12','2029-02-23','2029-03-20','2029-04-29','2029-04-30','2029-05-03','2029-05-04','2029-05-05','2029-07-16','2029-08-11','2029-08-13','2029-08-14','2029-08-15','2029-08-16','2029-09-17','2029-09-23','2029-09-24','2029-10-08','2029-11-03','2029-11-23','2029-12-29','2029-12-30','2029-12-31','2030-01-01','2030-01-02','2030-01-03','2030-01-14','2030-02-11','2030-02-23','2030-03-20','2030-04-29','2030-05-03','2030-05-04','2030-05-05','2030-05-06','2030-07-15','2030-08-11','2030-08-12','2030-08-13','2030-08-14','2030-08-15','2030-08-16','2030-09-16','2030-09-23','2030-10-14','2030-11-03','2030-11-04','2030-11-23','2030-12-29','2030-12-30','2030-12-31'];
  var LETTERING_FONTS = [
    'ゴシック（Noto Sans JP）',
    '丸ゴシック（M PLUS Rounded 1c）',
    'ポップ（RocknRoll One）',
    '手書き風（Yusei Magic）'
  ];
  function forzaValidLetteringFont(value) {
    return LETTERING_FONTS.indexOf(String(value || '').trim()) !== -1;
  }
  var COLOR_FILE_KEYS = {
    'ブラック': 'black',
    'マットブラック': 'matblack',
    'ホワイト': 'white',
    'マットホワイト': 'matwhite',
    'レッド': 'red',
    'シクラメン': 'cyclamen',
    'ピンク': 'pink',
    'オレンジ': 'orange',
    'イエロー': 'yellow',
    'レモンイエロー': 'lemonyellow',
    'ライム': 'lime',
    'ボトルグリーン': 'bottlegreen',
    'ミント': 'mint',
    'スカイブルー': 'skyblue',
    'ブルー': 'blue',
    'ロイヤルブルー': 'loyalblue',
    'パープル': 'violet',
    'ラベンダー': 'lavender',
    'ライラック': 'lilac',
    'ベージュ': 'beige',
    'コッパー': 'copper',
    'ゴールド': 'gold',
    'シルバー': 'silver',
    'グレー': 'gray',
    'ダークグレー': 'darkgray',
  };
  function applyColorImage(img, handle, colorLabel) {
    var fileKey = COLOR_FILE_KEYS[colorLabel];
    if (!img || !handle || !fileKey) return;
    var seq = (img._forzaColorImageSeq || 0) + 1;
    img._forzaColorImageSeq = seq;
    var preload = new Image();
    preload.onload = function () {
      if (img._forzaColorImageSeq !== seq) return;
      img.removeAttribute('srcset');
      img.src = preload.src;
    };
    preload.onerror = function () {};
    preload.src = 'https://cdn.shopify.com/s/files/1/0826/4581/1484/files/' + handle + '-' + fileKey + '.jpg';
  }

  var forzaCartAddedLayer = null;
  var forzaCartAddedReturnFocus = null;

  function forzaElement(tag, className, textValue) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (textValue !== undefined) element.textContent = textValue;
    return element;
  }

  function forzaMoney(cents) {
    return '¥' + Math.round((Number(cents) || 0) / 100).toLocaleString('ja-JP');
  }

  function forzaFormValue(formData, name) {
    var value = formData.get(name);
    return typeof value === 'string' ? value : '';
  }

  function forzaSubmittedProperties(formData) {
    var properties = {};
    formData.forEach(function (value, name) {
      var match = /^properties\[(.+)\]$/.exec(name);
      if (match && typeof value === 'string' && value !== '') properties[match[1]] = value;
    });
    return properties;
  }

  function forzaFindAddedItem(cart, formData) {
    var variantId = forzaFormValue(formData, 'id');
    var properties = forzaSubmittedProperties(formData);
    var propertyNames = Object.keys(properties);
    var candidates = (cart.items || []).filter(function (item) {
      return !variantId || String(item.variant_id) === String(variantId);
    });
    var exact = candidates.find(function (item) {
      var itemProperties = item.properties || {};
      var itemPropertyNames = Object.keys(itemProperties).filter(function (name) {
        return itemProperties[name] != null && String(itemProperties[name]) !== '';
      });
      return itemPropertyNames.length === propertyNames.length && propertyNames.every(function (name) {
        return String(itemProperties[name] || '') === properties[name];
      });
    });
    return exact || candidates[0] || (cart.items && cart.items[0]) || null;
  }

  function forzaItemProperty(item, submitted, name) {
    if (Object.prototype.hasOwnProperty.call(submitted, name)) return submitted[name];
    var value = item && item.properties ? item.properties[name] : '';
    return value == null ? '' : String(value);
  }

  function forzaHasItemProperty(item, submitted, name) {
    return Object.prototype.hasOwnProperty.call(submitted, name) ||
      !!(item && item.properties && Object.prototype.hasOwnProperty.call(item.properties, name));
  }

  function forzaSpecRow(list, label, value) {
    var row = forzaElement('div');
    row.appendChild(forzaElement('dt', '', label));
    row.appendChild(forzaElement('dd', '', value));
    list.appendChild(row);
  }

  function closeForzaCartAddedDrawer() {
    if (!forzaCartAddedLayer || !forzaCartAddedLayer.classList.contains('is-open')) return;
    forzaCartAddedLayer.classList.remove('is-open');
    forzaCartAddedLayer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('f-cart-added-open');
    var returnFocus = forzaCartAddedReturnFocus;
    forzaCartAddedReturnFocus = null;
    if (returnFocus && document.documentElement.contains(returnFocus)) returnFocus.focus();
  }

  function ensureForzaCartAddedDrawer() {
    if (forzaCartAddedLayer) return forzaCartAddedLayer;
    var layer = forzaElement('div', 'f-cart-added');
    layer.setAttribute('aria-hidden', 'true');
    var overlay = forzaElement('div', 'f-cart-added__overlay');
    overlay.setAttribute('aria-hidden', 'true');
    var panel = forzaElement('div', 'f-cart-added__panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', 'ForzaCartAddedTitle');
    panel.setAttribute('tabindex', '-1');
    var head = forzaElement('div', 'f-cart-added__head');
    var title = forzaElement('h2', 'f-cart-added__title', 'カートに追加しました');
    title.id = 'ForzaCartAddedTitle';
    var closeButton = forzaElement('button', 'f-cart-added__close', '×');
    closeButton.type = 'button';
    closeButton.setAttribute('aria-label', 'カート追加パネルを閉じる');
    var content = forzaElement('div', 'f-cart-added__content');
    head.appendChild(title);
    head.appendChild(closeButton);
    panel.appendChild(head);
    panel.appendChild(content);
    layer.appendChild(overlay);
    layer.appendChild(panel);
    document.body.appendChild(layer);
    layer._forzaPanel = panel;
    layer._forzaContent = content;
    layer._forzaClose = closeButton;
    closeButton.addEventListener('click', closeForzaCartAddedDrawer);
    overlay.addEventListener('click', closeForzaCartAddedDrawer);
    document.addEventListener('keydown', function (event) {
      if (!layer.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeForzaCartAddedDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = panel.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])');
      if (!focusable.length) {
        event.preventDefault();
        panel.focus();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    });
    forzaCartAddedLayer = layer;
    return layer;
  }

  function openForzaCartAddedDrawer(cart, formData, returnFocus, root) {
    var item = forzaFindAddedItem(cart, formData);
    if (!item) return;
    var submitted = forzaSubmittedProperties(formData);
    var quantity = Math.max(1, parseInt(forzaFormValue(formData, 'quantity') || '1', 10) || 1);
    var color = forzaItemProperty(item, submitted, 'カラー') || '—';
    var hasLettering = forzaHasItemProperty(item, submitted, '文字入れ');
    var lettering = hasLettering ? forzaItemProperty(item, submitted, '文字入れ') : '';
    if (hasLettering && (!lettering || lettering === '文字入れ希望しない')) lettering = 'なし';
    var hasFont = forzaHasItemProperty(item, submitted, 'フォント');
    var font = hasFont ? forzaItemProperty(item, submitted, 'フォント') : '';
    var size = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '—';
    var name = item.product_title || item.title || '';
    var imageUrl = item.image || (item.featured_image && item.featured_image.url) || '';
    var handle = item.handle || item.product_handle || '';
    if (!handle && item.url) {
      var handleMatch = /\/products\/([^/?#]+)/.exec(item.url);
      if (handleMatch) handle = decodeURIComponent(handleMatch[1]);
    }
    var layer = ensureForzaCartAddedDrawer();
    var content = layer._forzaContent;
    content.textContent = '';
    var product = forzaElement('div', 'f-cart-added__product');
    var image = forzaElement('img', 'f-cart-added__image');
    if (imageUrl) image.src = imageUrl;
    image.alt = name ? name + 'の画像' : '追加した商品の画像';
    product.appendChild(image);
    var meta = forzaElement('div');
    meta.appendChild(forzaElement('p', 'f-cart-added__name', name));
    var specs = forzaElement('dl', 'f-cart-added__spec');
    forzaSpecRow(specs, 'サイズ', size);
    forzaSpecRow(specs, 'カラー', color);
    if (hasLettering) forzaSpecRow(specs, '文字入れ', lettering);
    if (hasFont) forzaSpecRow(specs, 'フォント', font);
    forzaSpecRow(specs, '数量', String(quantity));
    forzaSpecRow(specs, '金額', forzaMoney((item.final_price != null ? item.final_price : item.price) * quantity));
    meta.appendChild(specs);
    product.appendChild(meta);
    content.appendChild(product);
    content.appendChild(forzaElement('hr', 'f-cart-added__line'));
    var subtotal = forzaElement('div', 'f-cart-added__sumrow');
    subtotal.appendChild(forzaElement('span', '', '小計（税込）'));
    subtotal.appendChild(forzaElement('span', '', forzaMoney(cart.total_price)));
    content.appendChild(subtotal);
    var shipping = forzaElement('div', 'f-cart-added__sumrow f-cart-added__sumrow--free');
    shipping.appendChild(forzaElement('span', '', '送料'));
    shipping.appendChild(forzaElement('span', '', '無料'));
    content.appendChild(shipping);
    var shippingNote = forzaElement('p', 'f-cart-added__note');
    shippingNote.appendChild(document.createTextNode('本日ご注文で '));
    var shippingDate = forzaElement('strong');
    shippingDate.setAttribute('data-forza-ship', '');
    shippingNote.appendChild(shippingDate);
    shippingNote.appendChild(document.createTextNode(' 出荷予定'));
    content.appendChild(shippingNote);
    var actions = forzaElement('div', 'f-cart-added__actions');
    var checkout = forzaElement('form', 'f-cart-added__checkout');
    checkout.method = 'post';
    checkout.action = root + 'cart';
    var checkoutButton = forzaElement('button', 'f-btn f-btn--full', 'レジに進む');
    checkoutButton.type = 'submit';
    checkoutButton.name = 'checkout';
    var invalidLetteringFont = false;
    var incompleteLettering = false;
    (cart.items || []).forEach(function (line) {
      if (line.handle !== 'moji-order-made') return;
      var props = line.properties || {};
      if (String(props['フォント'] || '').trim() && !forzaValidLetteringFont(props['フォント'])) invalidLetteringFont = true;
      if (!String(props['文字入れ'] || '').trim() || !forzaValidLetteringFont(props['フォント']) || !String(props['カラー'] || '').trim()) incompleteLettering = true;
    });
    if (incompleteLettering) {
      checkoutButton.disabled = true;
      checkout.appendChild(forzaElement('p', 'f-ng-error', invalidLetteringFont ? '現在選べないフォントがカートにあります。「カートを見る」から削除して、商品ページで選び直してください。' : '文字オーダーの指定が不足しています。「カートを見る」から内容を確認してください。'));
    }
    checkout.appendChild(checkoutButton);
    actions.appendChild(checkout);
    var continueButton = forzaElement('button', 'f-cart-added__continue', '買い物を続ける');
    continueButton.type = 'button';
    continueButton.addEventListener('click', closeForzaCartAddedDrawer);
    actions.appendChild(continueButton);
    content.appendChild(actions);
    var footer = forzaElement('div', 'f-cart-added__footer');
    footer.appendChild(forzaElement('span', '', 'カートに' + cart.item_count + '点'));
    var cartLink = forzaElement('a', 'f-cart-added__cartlink', 'カートを見る');
    cartLink.href = root + 'cart';
    footer.appendChild(cartLink);
    content.appendChild(footer);
    if (color !== '—') applyColorImage(image, handle, color);
    updateForzaShipDates();
    forzaCartAddedReturnFocus = returnFocus;
    layer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('f-cart-added-open');
    layer.classList.add('is-open');
    layer._forzaClose.focus();
  }

  var forzaNgWordEntries = null;

  function forzaNormalizeNgText(value) {
    var normalized = String(value == null ? '' : value);
    if (typeof normalized.normalize === 'function') normalized = normalized.normalize('NFKC');
    normalized = normalized.replace(/[ぁ-ゖ]/g, function (character) {
      return String.fromCharCode(character.charCodeAt(0) + 0x60);
    });
    return normalized.toUpperCase().replace(/[^0-9A-Zァ-ヿ一-鿿々〆ヵヶ]/g, '');
  }

  function forzaLoadNgWords() {
    if (forzaNgWordEntries) return forzaNgWordEntries;
    var words = [];
    var source = document.getElementById('ForzaNgWords');
    if (source) {
      try {
        var parsed = JSON.parse(source.textContent);
        if (Array.isArray(parsed)) words = parsed;
      } catch (error) {}
    }
    document.querySelectorAll('[data-forza-ng-words-extra]').forEach(function (extraSource) {
      try {
        var extraText = JSON.parse(extraSource.textContent);
        if (typeof extraText === 'string') {
          words = words.concat(extraText.split(/[\n,]+/));
        }
      } catch (error) {}
    });
    var seen = {};
    forzaNgWordEntries = words.map(function (word) {
      var label = String(word == null ? '' : word).trim();
      return { label: label, normalized: forzaNormalizeNgText(label) };
    }).filter(function (entry) {
      if (!entry.normalized || seen[entry.normalized]) return false;
      seen[entry.normalized] = true;
      return true;
    });
    return forzaNgWordEntries;
  }

  function forzaFindNgWord(value) {
    var normalizedValue = forzaNormalizeNgText(value);
    if (!normalizedValue) return null;
    return forzaLoadNgWords().find(function (entry) {
      return normalizedValue.indexOf(entry.normalized) !== -1;
    }) || null;
  }

  function forzaClearNgError(input) {
    if (!input) return;
    var field = input.closest('[data-forza-ng-field]');
    var message = field ? field.querySelector('[data-forza-ng-error]') : null;
    input.classList.remove('is-error');
    input.removeAttribute('aria-invalid');
    if (message) {
      message.textContent = '';
      message.hidden = true;
    }
  }

  function forzaShowMojiRequiredError(input, shouldFocus) {
    if (!input) return;
    var field = input.closest('[data-forza-ng-field]');
    var message = field ? field.querySelector('[data-forza-ng-error]') : null;
    input.classList.add('is-error');
    input.setAttribute('aria-invalid', 'true');
    input.placeholder = '文字を入力してください';
    if (message) {
      message.textContent = '文字を入力してください';
      message.hidden = false;
    }
    if (shouldFocus) input.focus();
  }

  function forzaValidateNgInput(input, shouldFocus) {
    if (!input) return true;
    if (input.hasAttribute('data-forza-lettering-input')) {
      var letteringError = '';
      if (!input.value.trim()) letteringError = shouldFocus ? '作りたい文字を入力してください。' : '';
      else if (/[\p{Extended_Pictographic}\p{Regional_Indicator}\uFE0F\u20E3\u200D\u{1F3FB}-\u{1F3FF}]/u.test(input.value)) letteringError = '絵文字は製作できません。文字で入力してください。';
      if (letteringError) {
        var letteringField = input.closest('[data-forza-ng-field]');
        var letteringMessage = letteringField && letteringField.querySelector('[data-forza-ng-error]');
        input.classList.add('is-error'); input.setAttribute('aria-invalid', 'true');
        if (letteringMessage) { letteringMessage.textContent = letteringError; letteringMessage.hidden = false; }
        if (shouldFocus) input.focus();
        return false;
      }
    }
    var maxChars = parseInt(input.dataset.forzaMaxChars, 10);
    if (maxChars > 0 && Array.from(input.value).length > maxChars) {
      var lengthField = input.closest('[data-forza-ng-field]');
      var lengthMessage = lengthField ? lengthField.querySelector('[data-forza-ng-error]') : null;
      input.classList.add('is-error');
      input.setAttribute('aria-invalid', 'true');
      if (lengthMessage) {
        lengthMessage.textContent = 'このサイズは' + maxChars + '文字までです。文字を減らしてください。';
        lengthMessage.hidden = false;
      }
      if (shouldFocus) input.focus();
      return false;
    }
    var match = forzaFindNgWord(input.value);
    if (!match) {
      forzaClearNgError(input);
      return true;
    }
    var field = input.closest('[data-forza-ng-field]');
    var message = field ? field.querySelector('[data-forza-ng-error]') : null;
    input.classList.add('is-error');
    input.setAttribute('aria-invalid', 'true');
    if (message) {
      message.textContent = '他社の商標・キャラクター名などは製作できません（' + match.label + '）';
      message.hidden = false;
    }
    if (shouldFocus) input.focus();
    return false;
  }

  function forzaSyncRightsConfirmation(root) {
    if (!root) return;
    var checkbox = root.querySelector('[data-forza-rights-checkbox]');
    var propertyInput = root.querySelector('[data-forza-rights-property]');
    if (propertyInput) propertyInput.disabled = !(checkbox && checkbox.checked);
    if ((checkbox && checkbox.checked) || root.hidden) {
      root.classList.remove('is-error');
      checkbox.removeAttribute('aria-invalid');
      var error = root.querySelector('[data-forza-rights-error]');
      if (error) error.hidden = true;
    }
  }

  function forzaValidateRightsConfirmation(root, shouldFocus) {
    if (!root || root.hidden) return true;
    var checkbox = root.querySelector('[data-forza-rights-checkbox]');
    if (checkbox && checkbox.checked) {
      forzaSyncRightsConfirmation(root);
      return true;
    }
    root.classList.add('is-error');
    if (checkbox) {
      checkbox.setAttribute('aria-invalid', 'true');
      if (shouldFocus) checkbox.focus();
    }
    var error = root.querySelector('[data-forza-rights-error]');
    if (error) error.hidden = false;
    return false;
  }

  function key(d){ return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0'); }
  function isClosed(d){ return d.getDay() === 0 || d.getDay() === 6 || HOLIDAYS.indexOf(key(d)) >= 0; }
  function fmt(d){ return (d.getMonth()+1) + '/' + d.getDate() + '（' + '日月火水木金土'[d.getDay()] + '）'; }
  function addBiz(n){ var d = new Date(), a = 0; while (a < n) { d.setDate(d.getDate()+1); if (!isClosed(d)) a++; } return d; }

  function updateForzaShipDates() {
    document.querySelectorAll('[data-forza-ship]').forEach(function (el) {
      el.textContent = fmt(addBiz(2));
    });
  }

  // 商品ページだけを対象に、サイズ表記中の最大数値で小さい順へ並べる。
  // 数値を解釈できない選択肢が1つでもある場合は、Shopifyの登録順をそのまま保つ。
  function forzaSortProductSizes(form) {
    if (!form) return;
    var list = form.querySelector('[data-forza-size-sort]');
    if (!list) return;
    var items = Array.prototype.slice.call(list.children).filter(function (item) {
      return item.classList.contains('f-size');
    });
    if (items.length < 2) return;

    var keyed = items.map(function (item, index) {
      var input = item.querySelector('input[name="id"]');
      var title = input ? input.dataset.variantTitle || '' : '';
      var matches = title.match(/\d+(?:\.\d+)?/g);
      var values = matches ? matches.map(Number).filter(Number.isFinite) : [];
      return {
        item: item,
        input: input,
        index: index,
        key: values.length ? Math.max.apply(null, values) : null
      };
    });

    if (keyed.some(function (entry) { return entry.key === null; })) return;

    var selected = keyed.find(function (entry) {
      return entry.input && entry.input.checked && !entry.input.disabled;
    });
    keyed.sort(function (a, b) {
      return a.key === b.key ? a.index - b.index : a.key - b.key;
    });
    keyed.forEach(function (entry) { list.appendChild(entry.item); });

    selected = selected || keyed.find(function (entry) {
      return entry.input && !entry.input.disabled;
    });
    if (!selected) return;
    keyed.forEach(function (entry) {
      if (entry.input) entry.input.checked = entry === selected;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateForzaShipDates();

    forzaSortProductSizes(document.getElementById('ForzaProductForm'));

    document.querySelectorAll('[data-forza-moji]').forEach(function (root) {
      var onBtn = root.querySelector('[data-moji-on]');
      var offBtn = root.querySelector('[data-moji-off]');
      var wrap = root.querySelector('[data-moji-input-wrap]');
      var input = root.querySelector('input[name="properties[文字入れ]"]');
      var form = root.closest('form');
      var rightsRoot = form ? form.querySelector('[data-forza-rights-normal]') : null;
      var originalPlaceholder = input ? input.getAttribute('placeholder') || '' : '';
      if (!onBtn || !offBtn) return;
      function clearMojiError() {
        if (!input) return;
        forzaClearNgError(input);
        input.placeholder = originalPlaceholder;
      }
      function set(on) {
        onBtn.classList.toggle('is-selected', on);
        offBtn.classList.toggle('is-selected', !on);
        onBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        offBtn.setAttribute('aria-pressed', on ? 'false' : 'true');
        if (wrap) wrap.hidden = !on;
        if (rightsRoot) {
          rightsRoot.hidden = !on;
          var rightsCheckbox = rightsRoot.querySelector('[data-forza-rights-checkbox]');
          if (!on && rightsCheckbox) {
            rightsCheckbox.checked = false;
            rightsCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        if (on && input && input.value === '文字入れ希望しない') input.value = '';
        if (!on && input) {
          clearMojiError();
          input.value = '';
          if (!input.value) input.value = '文字入れ希望しない';
        }
      }
      if (input) {
        input.addEventListener('input', clearMojiError);
        input.addEventListener('invalid', function (e) {
          if (input.disabled || input.value.trim() !== '') return;
          e.preventDefault();
          forzaShowMojiRequiredError(input, true);
        });
      }
      onBtn.addEventListener('click', function (e) { e.preventDefault(); set(true); });
      offBtn.addEventListener('click', function (e) { e.preventDefault(); set(false); });
      set(true);
    });

    document.querySelectorAll('[data-forza-colors]').forEach(function (root) {
      var hidden = root.querySelector('input[name="properties[カラー]"]');
      var labels = root.querySelectorAll('[data-color-label-out]');
      var productRoot = root.closest('.f-product');
      var mainImage = productRoot ? productRoot.querySelector('[data-forza-main-image]') : null;
      root.querySelectorAll('.f-swatch').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          root.querySelectorAll('.f-swatch').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          if (hidden) hidden.value = btn.dataset.colorLabel;
          labels.forEach(function (l) { l.textContent = btn.dataset.colorLabel; });
          (root.closest('[data-forza-order]') || root).querySelectorAll('[data-forza-preview-text]').forEach(function (p) { p.style.color = btn.dataset.colorValue; });
          if (mainImage) applyColorImage(mainImage, mainImage.dataset.productHandle, btn.dataset.colorLabel);
        });
      });
      var first = root.querySelector('.f-swatch');
      if (first) first.click();
    });

    document.querySelectorAll('[data-forza-cart-img]').forEach(function (img) {
      if (img.dataset.color) applyColorImage(img, img.dataset.handle, img.dataset.color);
    });

    document.querySelectorAll('[data-forza-live-text]').forEach(function (input) {
      var scope = input.closest('[data-forza-order]');
      var target = scope ? scope.querySelector('[data-forza-preview-text]') : null;
      if (!target) return;
      var sync = function () { target.textContent = input.value.trim() || '文字を入力'; };
      input.addEventListener('input', sync); sync();
    });

    document.querySelectorAll('[data-forza-order]').forEach(function (orderRoot) {
      var input = orderRoot.querySelector('[data-forza-live-text]');
      var form = input ? input.form : null;
      var label = orderRoot.querySelector('[data-forza-maxchars-label]');
      if (!input || !form) return;
      var originalPlaceholder = input.getAttribute('placeholder') || '';
      function selectedMaxChars() {
        var sizeInput = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"][data-max-chars]');
        var maxChars = sizeInput ? parseInt(sizeInput.dataset.maxChars, 10) : 10;
        return maxChars > 0 ? Math.min(maxChars, 10) : 10;
      }
      function clearOrderTextError() {
        forzaClearNgError(input);
        input.placeholder = originalPlaceholder;
      }
      function applyMaxChars() {
        var maxChars = selectedMaxChars();
        input.dataset.forzaMaxChars = String(maxChars);
        input.maxLength = Math.max(maxChars * 2, input.value.length);
        if (label) label.textContent = maxChars + '文字まで';
        clearOrderTextError();
        forzaValidateNgInput(input, false);
      }
      input.addEventListener('input', applyMaxChars);
      form.addEventListener('change', function (e) {
        if (e.target.name === 'id') applyMaxChars();
      });
      applyMaxChars();
    });

    document.querySelectorAll('[data-forza-fonts]').forEach(function (root) {
      var orderRoot = root.closest('[data-forza-order]');
      var target = orderRoot ? orderRoot.querySelector('[data-forza-preview-text]') : null;
      var hidden = root.querySelector('input[name="properties[フォント]"]');
      function selectFont(btn) {
        root.querySelectorAll('button').forEach(function (b) {
          var selected = b === btn;
          b.classList.toggle('is-selected', selected);
          b.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (target) {
          target.style.fontFamily = "'" + btn.dataset.forzaFontFamily + "', sans-serif";
          target.style.fontWeight = btn.dataset.forzaFontWeight || '400';
        }
        if (hidden) hidden.value = btn.dataset.forzaFontValue;
        var url = btn.dataset.forzaFontUrl;
        if (url) {
          var linkId = 'ForzaFont-' + btn.dataset.forzaFontKey;
          if (!document.getElementById(linkId)) {
            var link = document.createElement('link');
            link.id = linkId;
            link.rel = 'stylesheet';
            link.href = url;
            document.head.appendChild(link);
          }
        }
      }
      root.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); selectFont(btn); });
      });
      var selected = root.querySelector('button.is-selected') || root.querySelector('button');
      if (selected) selectFont(selected);
    });

    document.querySelectorAll('[data-forza-ng-input]').forEach(function (input) {
      input.addEventListener('input', function () { forzaValidateNgInput(input, false); });
      forzaValidateNgInput(input, false);
    });

    document.querySelectorAll('[data-forza-rights]').forEach(function (root) {
      var checkbox = root.querySelector('[data-forza-rights-checkbox]');
      if (checkbox) checkbox.addEventListener('change', function () { forzaSyncRightsConfirmation(root); });
      forzaSyncRightsConfirmation(root);
    });

    document.querySelectorAll('[data-forza-bg]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var group = btn.parentElement;
        if (group) group.querySelectorAll('.f-order__bg').forEach(function (b) {
          var selected = b === btn;
          b.classList.toggle('is-selected', selected);
          b.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        var panel = btn.closest('.f-order__panel');
        var target = panel ? panel.querySelector('[data-forza-preview]') : null;
        if (target) target.style.background = btn.dataset.forzaBg;
      });
    });

    // 数量 +/-（商品ページ・カート共通）。カートでは変更後にformをsubmit
    document.querySelectorAll('[data-forza-qty]').forEach(function (root) {
      var input = root.querySelector('input');
      root.querySelectorAll('button[data-qty]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var v = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
          input.value = v;
          if (root.dataset.forzaQty === 'submit') { input.form && input.form.submit(); }
          else { input.dispatchEvent(new Event('input', { bubbles: true })); }
        });
      });
    });

    // 価格・合計の動的更新（バリアント切替 × 数量。表記はShopifyのmoneyフォーマットを踏襲）
    function moneyDigits(s){ return parseInt(String(s).replace(/[^0-9]/g, ''), 10) || 0; }
    function moneyWith(template, n){ return String(template).replace(/[\d,]+/, n.toLocaleString('ja-JP')); }
    var pform = document.getElementById('ForzaProductForm');
    if (pform) {
      var qty = pform.querySelector('input[name="quantity"]');
      function selectedPriceFmt(){
        var r = pform.querySelector('input[name="id"]:checked');
        if (r && r.dataset.priceFormatted) return r.dataset.priceFormatted;
        var h = pform.querySelector('input[name="id"][data-price-formatted]');
        return h ? h.dataset.priceFormatted : null;
      }
      function updateTotal(){
        var fmtP = selectedPriceFmt();
        if (!fmtP) return;
        var q = Math.max(1, parseInt(qty && qty.value, 10) || 1);
        var text = moneyWith(fmtP, moneyDigits(fmtP) * q);
        document.querySelectorAll('[data-forza-total]').forEach(function (el) { el.textContent = text; });
      }
      pform.addEventListener('change', function (e) {
        if (e.target.name === 'id') updateTotal();
      });
      if (qty) qty.addEventListener('input', updateTotal);
      updateTotal();
    }
    // 文字オーダーメイド: 選択サイズの価格表示
    document.querySelectorAll('[data-forza-order-price]').forEach(function (el) {
      var f = el.closest('form');
      if (!f) return;
      f.addEventListener('change', function (e) {
        if (e.target.name === 'id' && e.target.dataset.priceFormatted) el.textContent = e.target.dataset.priceFormatted;
      });
      var checked = f.querySelector('input[name="id"]:checked');
      if (checked && checked.dataset.priceFormatted) el.textContent = checked.dataset.priceFormatted;
    });

    // カート追加はAJAX（正本UX: ページ内に留まり「追加しました ✓」を1.6秒表示、バッジ更新）
    var lastSubmitter = null;
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button[type="submit"], button[form], input[type="submit"]') : null;
      if (b) lastSubmitter = b;
    }, true);
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;
      var mojiRoot = form.querySelector('[data-forza-moji]');
      if (mojiRoot) {
        var mojiOn = mojiRoot.querySelector('[data-moji-on]');
        var mojiInput = mojiRoot.querySelector('input[name="properties[文字入れ]"]');
        var wantsMoji = mojiOn && mojiOn.classList.contains('is-selected');
        if (wantsMoji && mojiInput && mojiInput.value.trim() === '') {
          e.preventDefault();
          forzaShowMojiRequiredError(mojiInput, true);
          return;
        }
      }
      var orderRoot = form.closest('[data-forza-order]');
      var orderInput = orderRoot ? orderRoot.querySelector('[data-forza-live-text]') : null;
      var letteringInput = orderInput || (mojiRoot && wantsMoji ? mojiInput : null);
      var fontInput = orderRoot ? form.querySelector('input[name="properties[フォント]"]') : null;
      if (orderRoot && (!orderInput || !fontInput || !forzaValidLetteringFont(fontInput.value))) {
        e.preventDefault();
        if (orderInput) { orderInput.setCustomValidity('現在選べるフォントを選んでください。'); orderInput.reportValidity(); }
        return;
      }
      if (letteringInput && !forzaValidateNgInput(letteringInput, true)) {
        e.preventDefault();
        return;
      }
      var rightsRoot = form.querySelector('[data-forza-rights]');
      if (!forzaValidateRightsConfirmation(rightsRoot, true)) {
        e.preventDefault();
        return;
      }
      if (form._forzaAdding) { e.preventDefault(); return; }
      e.preventDefault();
      form._forzaAdding = true;
      var btn = e.submitter || (lastSubmitter && lastSubmitter.form === form ? lastSubmitter : null) || form.querySelector('[type="submit"]') || document.querySelector('button[form="' + form.id + '"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput) {
        var qtyValue = parseInt(qtyInput.value, 10);
        if (isNaN(qtyValue) || qtyValue < 1) qtyInput.value = '1';
      }
      var fd = new FormData(form);
      var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      var added = false;
      fetch(root + 'cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { if (!r.ok) throw 0; added = true; return r.json(); })
        .then(function () { return fetch(root + 'cart.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }); })
        .then(function (cart) {
          document.querySelectorAll('[data-forza-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          document.querySelectorAll('[data-forza-cart-badge]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
          if (btn) {
            if (btn._forzaTimer) { clearTimeout(btn._forzaTimer); }
            else { btn._forzaOrigHtml = btn.innerHTML; }
            btn.textContent = '追加しました ✓';
            btn._forzaTimer = setTimeout(function () {
              btn.innerHTML = btn._forzaOrigHtml;
              btn._forzaTimer = null;
            }, 1600);
          }
          openForzaCartAddedDrawer(cart, fd, btn, root);
          form._forzaAdding = false;
        })
        .catch(function () { form._forzaAdding = false; if (!added) form.submit(); });
    });

    // 商品メディア切替
    document.querySelectorAll('[data-forza-thumbs]').forEach(function (root) {
      var main = document.querySelector('[data-forza-main-image]');
      if (!main) return;
      root.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          main._forzaColorImageSeq = (main._forzaColorImageSeq || 0) + 1;
          main.removeAttribute('srcset');
          main.src = btn.dataset.src;
          root.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-current'); });
          btn.classList.add('is-current');
        });
      });
    });

    // 営業日カレンダー（フッター）
    document.querySelectorAll('[data-forza-calendar]').forEach(function (root) {
      var now = new Date(), yy = now.getFullYear(), mm = now.getMonth();
      var html = '';
      ['日','月','火','水','木','金','土'].forEach(function (w, i) {
        html += '<div class="f-cal__dow' + (i === 0 ? ' f-cal__dow--sun' : '') + '">' + w + '</div>';
      });
      var firstDow = new Date(yy, mm, 1).getDay();
      var daysIn = new Date(yy, mm + 1, 0).getDate();
      for (var i = 0; i < firstDow; i++) html += '<div></div>';
      for (var d = 1; d <= daysIn; d++) {
        var dd = new Date(yy, mm, d);
        var closed = isClosed(dd), today = d === now.getDate();
        var cls = 'f-cal__day' + (closed ? ' f-cal__day--closed' : '') + (today ? ' f-cal__day--today' : '');
        var label = (mm + 1) + '月' + d + '日・' + (closed ? '休業日' : '営業日') + (today ? '・今日' : '');
        html += '<div class="' + cls + '" aria-label="' + label + '" title="' + label + '"' + (today ? ' aria-current="date"' : '') + '>' + d + '</div>';
      }
      root.querySelector('.f-cal__grid').innerHTML = html;
      var head = root.querySelector('[data-cal-month]');
      if (head) head.textContent = yy + '年' + (mm + 1) + '月';
    });
  });
})();

/* お問い合わせ種別別案内・受付対象外切替（FORZA-v1移植・2026-08-07） */
(function () {
  var BLOCKED_CONTACTS = {
    '配送状況について': {
      kicker: 'ANSWER',
      title: '配送状況は、配送業者へお問い合わせください。',
      textOne: '発送後のお荷物の位置や再配達のお手続きは、当店では確認できません。お手元の追跡番号で、配送業者のサイトからご確認ください。多くのご注文は日本郵便でお届けしています（商品によりヤマト運輸の場合があります）。',
      textTwo: '追跡番号が届いていない場合や、発送そのものが確認できない場合は、お問い合わせ種別を「注文内容について」に変えてお送りください。',
      linkText: '日本郵便の追跡サービス →',
      linkUrl: 'https://trackings.post.japanpost.jp/services/srv/search/input'
    },
    '貼り方・使い方について': {
      kicker: 'ANSWER',
      title: '貼り方は、写真つきの記事でご案内しています。',
      textOne: '水貼り（ウェット工法）とドライ貼り（空貼り）の手順を、写真つきでまとめています。転写シートの剥がし方や、位置を決めるコツもこちらに載せています。',
      textTwo: '記事を読んでも解決しない場合は、お問い合わせ種別を「その他」に変えて、困っている状況をお書きください。',
      linkText: '貼り方の記事を読む →',
      linkUrl: 'https://forzagroup.jp/how-to-apply-cutting-sticker/'
    },
    '卸売・再販売・Amazon出品について': {
      kicker: 'ANSWER',
      title: '卸売・再販売は行っておりません。',
      textOne: '当店では、卸売、AmazonやECモール等での再販売、販売代理店契約、商品供給のご提案を受け付けておりません。',
      textTwo: 'この内容について個別にお問い合わせいただいても返信は行っておりません。当店の商品は、個人利用・自社利用を目的とするお客様向けです。卸売・仕入れ・転売・再販売を目的としたご注文はお断りしております。'
    }
  };
  var ORDER_REQUIRED_SUBJECTS = {
    '注文内容について': true,
    '不良・不足・破損について': true
  };
  var CONTACT_HELPERS = {
    '商品について': {
      title: '商品名または商品番号をご記入ください',
      text: 'サイズ・色・貼る場所については、ご利用ガイドでも確認できます。',
      linkText: '選び方を見る →',
      linkUrl: '/pages/guide'
    },
    '注文内容について': {
      title: '注文番号が必要です',
      text: '注文確認メールの注文番号をご入力ください。キャンセルをご希望の場合は、ご注文完了から1時間以内に、その旨をお送りください。期限は送信時刻で判断するため、返信をお待ちいただく間に1時間を過ぎても受付対象です。'
    },
    '不良・不足・破損について': {
      title: '注文番号と商品の状態をご記入ください',
      text: '不良箇所がわかる写真をお手元にご用意ください。送信後、当店から写真の送付方法をご案内します。'
    },
    '法人・大口注文について': {
      title: '使用目的と必要枚数をご記入ください',
      text: '卸売・再販売は行っていません。自社利用の大口注文についてのみ内容を確認します。'
    }
  };

  function setContactControlsDisabled(root, disabled) {
    root.querySelectorAll('[data-fz-contact-fields], [data-fz-contact-submit]').forEach(function (area) {
      area.querySelectorAll('input, textarea, select, button').forEach(function (control) {
        if (disabled) {
          if (!control.hasAttribute('data-fz-contact-was-disabled')) {
            control.setAttribute('data-fz-contact-was-disabled', control.disabled ? 'true' : 'false');
          }
          control.disabled = true;
        } else if (control.hasAttribute('data-fz-contact-was-disabled')) {
          control.disabled = control.getAttribute('data-fz-contact-was-disabled') === 'true';
          control.removeAttribute('data-fz-contact-was-disabled');
        }
      });
    });
  }

  function initForzaContact(root) {
    if (root.getAttribute('data-fz-contact-ready') === 'true') return;
    var subject = root.querySelector('[data-fz-contact-subject]');
    var helper = root.querySelector('[data-fz-contact-helper]');
    var helperTitle = root.querySelector('[data-fz-contact-helper-title]');
    var helperText = root.querySelector('[data-fz-contact-helper-text]');
    var helperLink = root.querySelector('[data-fz-contact-helper-link]');
    var blocked = root.querySelector('[data-fz-contact-blocked]');
    var blockedKicker = root.querySelector('[data-fz-contact-blocked-kicker]');
    var blockedTitle = root.querySelector('[data-fz-contact-blocked-title]');
    var blockedTextOne = root.querySelector('[data-fz-contact-blocked-text-one]');
    var blockedTextTwo = root.querySelector('[data-fz-contact-blocked-text-two]');
    var blockedLink = root.querySelector('[data-fz-contact-blocked-link]');
    var order = root.querySelector('[data-fz-contact-order]');
    var orderStatus = root.querySelector('[data-fz-contact-order-status]');
    var form = root.querySelector('form');
    if (!subject || !helper || !helperTitle || !helperText || !helperLink || !blocked || !blockedKicker || !blockedTitle || !blockedTextOne || !blockedTextTwo || !blockedLink || !form) return;
    root.setAttribute('data-fz-contact-ready', 'true');

    function updateContact() {
      var value = subject.value;
      var helperContent = CONTACT_HELPERS[value];
      var blockedContent = BLOCKED_CONTACTS[value];
      var isBlocked = !!blockedContent;
      var orderRequired = !!ORDER_REQUIRED_SUBJECTS[value];

      if (helperContent && !isBlocked) {
        helperTitle.textContent = helperContent.title;
        helperText.textContent = helperContent.text;
        if (helperContent.linkText && helperContent.linkUrl) {
          helperLink.textContent = helperContent.linkText;
          helperLink.setAttribute('href', helperContent.linkUrl);
          helperLink.hidden = false;
        } else {
          helperLink.textContent = '';
          helperLink.removeAttribute('href');
          helperLink.hidden = true;
        }
        helper.hidden = false;
      } else {
        helper.hidden = true;
        helperTitle.textContent = '';
        helperText.textContent = '';
        helperLink.textContent = '';
        helperLink.removeAttribute('href');
        helperLink.hidden = true;
      }

      if (blockedContent) {
        blockedKicker.textContent = blockedContent.kicker;
        blockedTitle.textContent = blockedContent.title;
        blockedTextOne.textContent = blockedContent.textOne;
        blockedTextTwo.textContent = blockedContent.textTwo;
        if (blockedContent.linkText && blockedContent.linkUrl) {
          blockedLink.textContent = blockedContent.linkText;
          blockedLink.setAttribute('href', blockedContent.linkUrl);
          blockedLink.hidden = false;
        } else {
          blockedLink.textContent = '';
          blockedLink.removeAttribute('href');
          blockedLink.hidden = true;
        }
      } else {
        blockedKicker.textContent = '';
        blockedTitle.textContent = '';
        blockedTextOne.textContent = '';
        blockedTextTwo.textContent = '';
        blockedLink.textContent = '';
        blockedLink.removeAttribute('href');
        blockedLink.hidden = true;
      }

      if (order) order.required = orderRequired;
      if (orderStatus) {
        orderStatus.textContent = orderRequired ? '必須' : '任意';
        orderStatus.classList.toggle('f-req', orderRequired);
        orderStatus.classList.toggle('f-opt', !orderRequired);
      }

      root.querySelectorAll('[data-fz-contact-fields], [data-fz-contact-submit]').forEach(function (area) {
        area.hidden = isBlocked;
      });
      setContactControlsDisabled(root, isBlocked);
      blocked.hidden = !isBlocked;
      if (isBlocked) blocked.focus();
    }

    subject.addEventListener('change', updateContact);
    form.addEventListener('submit', function (event) {
      if (BLOCKED_CONTACTS[subject.value]) event.preventDefault();
    });
    updateContact();
  }

  function initForzaContacts(scope) {
    if (scope.matches && scope.matches('[data-fz-contact-root]')) initForzaContact(scope);
    scope.querySelectorAll('[data-fz-contact-root]').forEach(initForzaContact);
  }

  function ready() {
    initForzaContacts(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
  document.addEventListener('shopify:section:load', function (event) {
    initForzaContacts(event.target);
  });
})();
